import {
    request,
} from '../request.js'

// 日志列表
export function logList(data) {
    return request({
        url: '/web/back/log/list',
        method: 'post',
        data
    })
}

// 删除
export function delLog(data) {
    return request({
        url: '/web/back/log/delete' + "?id=" + data,
        method: 'delete',
    })
}

// 批量删除
export function allDelLog(data) {
    return request({
        url: '/web/back/log/batch/delete',
        method: 'delete',
        data
    })
}

// 前端日志列表
export function foreEndLogList(data) {
    return request({
        url: '/fore/foreEndLog/findList',
        method: 'post',
        data
    })
}